<template>
  <div class="container-fluid">
      <div class="row">
         <div class="col-xl-9 col-lg-8">
            <div class="card">
               <div class="card-header d-flex justify-content-between">
                  <div class="header-title">
                     <h4 class="card-title">New User Information</h4>
                  </div>
               </div>
               
               <div class="card-body">
                  <div class="new-user-info">
                     <form @submit.prevent="postData" method="post">
                        <div class="row">
                           <div class="form-group">
                              <label for="username">User Name:</label>
                              <input type="text" class="form-control" name="username" v-model.trim="posts.username" placeholder="Username" required>
                           </div>
                           <br>

                           <div class="form-group">
                              <label for="merchant_code">Merchant Code</label>
                              <input type="text" class="form-control" name="merchant_code" v-model="posts.merchant_code" placeholder="Merchant Code" required>
                           </div>

                           <div class="form-group" :class="{ 'form-group--error': $v.posts.password.$error }">
                              <label for="password">Password</label>
                              <input type="password" class="form-control" name="password" v-model.trim="$v.posts.password.$model" placeholder="Password">                                 
                           </div>
                           <div class="error" v-if="!$v.posts.password.minLength">Password must have at least {{ $v.posts.password.$params.minLength.min }} letters.</div>

                           <div class="form-group" :class="{ 'form-group--error': $v.posts.re_password.$error }">
                              <label for="re_password">Retype Password</label>
                              <input type="password" class="form-control" name="re_password"  v-model.trim="$v.posts.re_password.$model" placeholder="Retype Password">
                           </div>
                           <div class="error" v-if="!$v.posts.re_password.sameAsPassword">Passwords must be identical.</div>
                              
                           <tree-view :data="$v" :options="{rootObjectKey: '$v', maxDepth: 2}"></tree-view>
                           <div class="form-group">
                              <label for="role">User Role:</label>
                              <b-form-select id="role" v-model="posts.role_id" required>
                                 <option value="">Please select...</option>
                                 <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.name">
                                    {{role.name}}
                                 </option>
                              </b-form-select>
                           </div>
                        </div>
                        <hr>
                        
                        <button type="submit" class="btn btn-primary float-right">Add New User</button>
                        <p class="typo__p" v-if="submitStatus === 'OK'">Thanks for your submission!</p>
                        <p class="typo__p" v-if="submitStatus === 'ERROR'">Please fill the form correctly.</p>
                        <p class="typo__p" v-if="submitStatus === 'PENDING'">Sending...</p>
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { validationMixin } from 'vuelidate'
import { required , minLength, sameAs} from 'vuelidate/lib/validators'

const config = require("../../../../../config");

Vue.use(VueAxios, axios);
export default {
   name:'UserAdd',
   mixins: [validationMixin],
   validations: {
      posts: {
         username: { required },
         merchant_code: { required },
         password: { required, minLength: minLength(6) },
         re_password: { required, sameAsPassword: sameAs('password') },
         role_id: { required }
      }
   },
   data() {
      return {
         posts: {
            username: "",
            merchant_code: "",
            password: "",
            re_password: "",
            role_id: "",
            status: 'active',
            language: 'en_US',
            created_by:"",
         },
         roles: null,
         submitStatus: null
      }
   },
   mounted: async function() {
      await this.getRoles();
   },
   methods: {
      postData: async function(e) {
         e.preventDefault();
         this.$v.$touch();
         var user = JSON.parse(localStorage.getItem("user"));
         this.posts.created_by = user.username

         if (this.$v.$invalid) {
            this.submitStatus = 'ERROR'
         }
         else {
            try {
               if(confirm("Are you sure you want to save this record?")) {
                  await axios.post(config.api.URL + '/api/newUser', this.posts, { params: { m: this.$route.meta.uid } });
                  this.submitStatus = 'PENDING';

                  setTimeout(() => {
                     this.submitStatus = 'OK';                  
                  }, 500);

                  alert("Record added successfully.")
                  this.$router.push({path: '/user/list'});
               }
            } catch(error) {
               alert("Error: Add user failed.")
               console.log("Error: ", error);
            }
         }
      },
      getRoles: async function() {
         try {
            const res = await axios.get(config.api.URL + '/api/roles', {
               params: {
                  m: this.$route.meta.uid
               }
            });
            
            this.roles = res.data;
         } catch(error) {
            console.log("Error: Unable to retrieve roles");
         }
      },      
   }
}
</script>